<p>package-config-popup works!</p>
